module.exports = __webpack_public_path__ + "static/media/Protrusion of the anterior teeth9.33697819.png";